import React from "react";
import Layout from "../../components/Layout";
import PagamentoPixContent from "../../components/PagamentoPixContent";

export default function PagamentoPix() {
  return (
    <Layout
      container
      header
      menuInternal={false}
      balcaoVirtual
      balcaoTitle="Tem dúvidas?"
      menuName="servicos"
    >
      <PagamentoPixContent />
    </Layout>
  );
}
